import {DefaultTheme as theme} from "../../../../../../../theme";
import {RoundedButton} from "../../../../../../../elements";
import {createSearchParams, useNavigate} from "react-router-dom";
import {ConversationTab} from "../../../../Section/EventName/EventName";
import {useStore} from "../../../../../../../hooks";
import {observer} from "mobx-react";
import Icon from "../../../../../../../elements/icon/Icon";
import {
  ActionIconWrapper,
  CreateButtonOptionWrapper,
  CreateButtonWrapper,
  ItemOptionWrapper
} from "./CreateButton.styled";
import React, {useState} from "react";
import {useUserCheckPermissions} from "../../../../../../../hooks/useUserCheckPermissions";
import Alerts from "../../../../../../../elements/v2/Alerts/Alerts";
import {PermissionCodes, PermissionLevels} from "../../../../../../../utils/enums";

export const CreateButton = observer(() => {
  const { viewConversationStore, marketingStore, authStore } = useStore();
  const { checkPermission, showAlert, closeAlert, warningMessageTitle } = useUserCheckPermissions();
  const navigate = useNavigate();
  const [isOpenMenu, setIsOpenMenu] = useState(false);
  
  const onNewTrigger = () => {
    viewConversationStore.clearNewModalForm();
    const eventId = viewConversationStore.event_id;
    viewConversationStore.updateFormField("event_id", "vwcustomers");
    viewConversationStore.updateFormField("eventName", "New Event");
    viewConversationStore.updateFormField("description", "Description");
    const redirectToTrigger = (id) => {
      setIsOpenMenu(false);
      navigate({
        pathname: "/v2/conversations/trigger",
        search: createSearchParams({ id, tabId: ConversationTab.Rules  }).toString(),
      });
    }
    viewConversationStore.onCreate(
      authStore.selectedAccount?.id,
      redirectToTrigger
    );
  };

  const onNewMarketing = async () => {
    const id = await marketingStore.newCampaign({ customer: authStore.selectedAccount.id });
    if(id){
      setIsOpenMenu(false);
      navigate({
        pathname: "/v2/conversations/marketing",
        search: createSearchParams({ id }).toString(),
      });
    }
  }
  
  const onToggleMenu = () => {
    setIsOpenMenu(!isOpenMenu);
  }
  
  return (
    <>
      <CreateButtonWrapper>
        {(checkPermission(PermissionCodes.CREATE_NEW, PermissionLevels.CREATE)) && (
            <RoundedButton
                width="99px"
                height="40px"
                color={theme.colors.activeBlue}
                onClick={onToggleMenu}
            >
              <ActionIconWrapper><Icon name="plus" width={"16px"} height={"16px"} /></ActionIconWrapper>New
            </RoundedButton>
        )}

        <CreateButtonOptionWrapper visible={isOpenMenu.toString()}>
          <ItemOptionWrapper onClick={onNewMarketing}>Marketing</ItemOptionWrapper>
          <ItemOptionWrapper onClick={onNewTrigger}>Triggers (soon)</ItemOptionWrapper>
        </CreateButtonOptionWrapper>
      </CreateButtonWrapper>
      {showAlert && (
          <Alerts severity="warning" message={warningMessageTitle} onClose={closeAlert}/>
      )}
    </>
  );
});
